module.exports = __webpack_public_path__ + "static/girl-looking-left-0281f4810fe6013028fb70714dc55ee2.jpg";